import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AlertController,
  ModalController,
  Platform,
  ToastController,
} from "@ionic/angular";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import * as fromApp from "../../store/app.reducer";
import * as AuthActions from "../../auth/store/auth.actions";
import * as _ from "lodash";
import { auditTime, distinctUntilChanged, first } from "rxjs/operators";
import { Subscription } from "rxjs";
import { getAuth } from "@firebase/auth";
import { FirebaseBrowserService } from "src/app/services/firebaseBrowser/firebase-browser.service";
import { AnalyticsServiceService } from "src/app/services/analitycsService/analytics-service.service";
import { Config } from "ng-otp-input/lib/models/config";
import { Capacitor } from "@capacitor/core";
import {
  AuthStateChange,
  FirebaseAuthentication,
} from "@capacitor-firebase/authentication";
import { OnlyDineInLoginAssistService } from "src/app/services/only-dinein-login-assist/only-dinein-login-assist.service";
import { OrderNowModalPopupsService } from "src/app/services/orderNowModalPopupsService/orderNowModalPopups.service";
import * as CurrentStoreActions from "src/app/store/current-store/current-store.actions";
import { DineinTableLabelService } from "../../services/dinein-table-label/dinein-table-label.service";

declare let window: any;
@Component({
  selector: "app-magic-login-confirmation",
  templateUrl: "./magic-login-confirmation.component.html",
  styleUrls: ["./magic-login-confirmation.component.scss"],
})
export class MagicLoginConfirmationComponent implements OnInit, OnDestroy {
  @ViewChild("ngOtpInput") ngOtpInputRef: any;
  @Input() newCustomer: any;
  public currentUser: any;
  public groupApp: any;
  public loading: boolean = false;
  public resendLoading: boolean = false;
  public showOtpComponent: boolean = false;
  public codeFull: boolean = false;
  public continueAsGuestLoading: boolean = false;
  public enterKey: any;
  public windowDimensions: any;
  private unsubscribeBackEvent: Subscription;
  private subscription: Subscription;
  private subscription2: Subscription;
  private subscription3: Subscription;
  private guestOrderAlertOpen: boolean = false;
  private guestOrderOfferDismissedAtInAuth: number | null = null;
  private continueAsGuestStoreId: any = null;
  private destroyed: boolean = false;
  config: Config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,

    containerStyles: {
      width: "100%",
    },
    inputStyles: {
      width: "37px",
      height: "37px",
      "font-size": "18px",
      "margin-right": "5px",
    },
  };

  constructor(
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private translateService: TranslateService,
    private store: Store<fromApp.AppState>,
    private toastController: ToastController,
    private firebaseBrowserService: FirebaseBrowserService,
    private platform: Platform,
    private analyticsService: AnalyticsServiceService,
    private onlyDineInLoginAssistService: OnlyDineInLoginAssistService,
    private orderNowModalPopupsService: OrderNowModalPopupsService,
    private dineinTableLabelService: DineinTableLabelService
  ) {}

  async ngOnInit() {
    this.showOtpComponent = true;

    console.log(this.newCustomer);
    this.unsubscribeBackEvent = this.platform.backButton.subscribeWithPriority(
      300,
      () => {
        if (this.platform.is("android")) {
          this.modalCtrl.dismiss();
        }
      }
    );
    this.subscription = this.store
      .select("auth")
      .pipe(distinctUntilChanged())
      .pipe(auditTime(200))
      .subscribe((state) => {
        if (
          state &&
          (typeof state.guestOrderOfferDismissedAt === "number" ||
            state.guestOrderOfferDismissedAt == null) &&
          state.guestOrderOfferDismissedAt !== this.guestOrderOfferDismissedAtInAuth
        ) {
          this.guestOrderOfferDismissedAtInAuth =
            state.guestOrderOfferDismissedAt == null
              ? null
              : Number(state.guestOrderOfferDismissedAt);
        }
        if (state && state.user && !_.isEqual(this.currentUser, state.user)) {
          this.currentUser = _.cloneDeep(state.user);
          if (this.currentUser) {
            this.presentAlertSuccessLogin();
            this.modalCtrl.dismiss();
          }
        }
      });

    this.subscription2 = this.store
      .select("groupApp")
      .pipe(distinctUntilChanged())
      .subscribe((state) => {
        if (
          state &&
          state.groupApp &&
          !_.isEqual(this.groupApp, state.groupApp)
        ) {
          this.groupApp = _.cloneDeep(state.groupApp);
        }
      });

    this.subscription3 = this.store
      .select("windowInfo")
      .pipe(distinctUntilChanged())
      .subscribe((state) => {
        if (
          state &&
          state.windowDimensions &&
          !_.isEqual(this.windowDimensions, state.windowDimensions)
        ) {
          this.windowDimensions = _.cloneDeep(state.windowDimensions);
          console.log("window dim", this.windowDimensions);
        }
      });
    // if (this.newCustomer && this.newCustomer.createOneTimePass) {
    //   this.newCustomer.createOneTimePass = false;
    //   _.omit(this.newCustomer, ["createOneTimePass"]);
    //   this.store.dispatch(
    //     new AuthActions.SetNewCustomer(_.cloneDeep(this.newCustomer))
    //   );
    // }

    // await FirebaseAuthentication.addListener(
    //   "authStateChange",
    //   async (event: AuthStateChange) => {
    //     if (event.user) {
    //       console.log("event.user", event.user);
    //       const result = await FirebaseAuthentication.getIdToken();
    //       console.log("result", result);
    //       this.writeToAuthStateDebounce("OK", result.token);
    //     }
    //   }
    // );
  }

  async presentErrorToast(message, color) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: "middle",

      color: color,
      buttons: [
        {
          side: "end",
          icon: "assets/ionicons/close.svg",

          handler: () => {
            console.log("Toast Closed");
          },
        },
      ],
    });
    toast.present();
  }

  private triggerResendSms() {
    this.writeToAuthStateDebounce("resend", null);
  }

  private shouldSuppressGuestOfferNow(): boolean {
    const dismissedAt = this.guestOrderOfferDismissedAtInAuth;
    if (dismissedAt == null) {
      return false;
    }

    const tenMinutesMs = 10 * 60 * 1000;
    return Date.now() - dismissedAt < tenMinutesMs;
  }

  private async presentContinueAsGuestAlert(opts?: { triggerResendOnNotNow?: boolean }) {
    if (this.destroyed || this.currentUser || this.guestOrderAlertOpen) {
      return;
    }

    const topModal: any = await this.modalCtrl.getTop();
    const otpModalStillOpen =
      !!topModal && !!topModal.classList?.contains?.("magicLoginConfirmation");
    if (!otpModalStillOpen) {
      return;
    }

    this.guestOrderAlertOpen = true;

    const alert = await this.alertCtrl.create({
      header: this.translateService.instant(
        "popups.magic-login-confirmation.guest-order-title",
      ),
      message: this.dineinTableLabelService.instant(
        "popups.magic-login-confirmation.guest-order-message",
      ),
      backdropDismiss: false,
      buttons: [
        {
          text: this.translateService.instant(
            "popups.magic-login-confirmation.not-now",
          ),
          role: "cancel",
          handler: () => {
            this.store.dispatch(
              new AuthActions.SetGuestOrderOfferDismissedAt(Date.now()),
            );
            if (opts?.triggerResendOnNotNow === true) {
              this.triggerResendSms();
            }
          },
        },
        {
          text: this.translateService.instant(
            "popups.dine-in-modal.continue-as-guest",
          ),
          handler: () => {
            void this.continueAsGuest();
          },
        },
      ],
    });

    alert.onDidDismiss().then(() => {
      this.guestOrderAlertOpen = false;
    });
    await alert.present();
  }

  private async handleResendGuestOfferFirstClick() {
    if (
      this.destroyed ||
      this.currentUser ||
      this.shouldSuppressGuestOfferNow()
    ) {
      return { handled: false };
    }

    const nearestEligibleStoreId =
      await this.onlyDineInLoginAssistService.getNearestEligibleStoreIdForContinueAsGuest(
        { maxDistanceMeters: 250 },
      );

    if (!nearestEligibleStoreId) {
      return { handled: false };
    }

    this.continueAsGuestStoreId = nearestEligibleStoreId;
    await this.presentContinueAsGuestAlert({ triggerResendOnNotNow: true });
    return { handled: true };
  }

  async continueAsGuest() {
    if (this.continueAsGuestLoading) {
      return;
    }
    this.continueAsGuestLoading = true;
    this.modalCtrl.dismiss();

    setTimeout(() => {
      this.openGuestDineInFlow();
    }, 250);
  }

  private openGuestDineInFlow() {
    const store_id = this.continueAsGuestStoreId;
    if (!store_id) {
      return;
    }

    this.store.dispatch(new CurrentStoreActions.SetCurrentStoreId(store_id));
    if (navigator.cookieEnabled) {
      window.localStorage.setItem("store_id", String(store_id));
    }

    this.store
      .select("stores")
      .pipe(first())
      .subscribe((storesState: any) => {
        this.store
          .select("deliveryMethodAddress")
          .pipe(first())
          .subscribe((deliveryMethodAddressState: any) => {
            const stores = storesState?.stores || [];
            const selectedAddress =
              deliveryMethodAddressState?.selectedAddress || null;

            if (stores && stores.length) {
              this.orderNowModalPopupsService.checkAndOpenSettingsModal(
                "dine-in",
                null,
                selectedAddress,
                stores,
                store_id,
                true,
                false,
                true,
              );
            }
          })
          .unsubscribe();
      })
      .unsubscribe();
  }

  handleEnterButton(event) {
    if ((event.key === "Enter" || event.keyCode === 13) && this.codeFull) {
      this.onClickOk();
    }
  }

  onClickOk() {
    this.analyticsService.dmAnalyticsMessage(
      "submit_password_button",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null
    );
    this.loading = true;
    console.log("this.newCustomer", this.newCustomer);
    if (!this.newCustomer || (this.newCustomer && !this.newCustomer.password)) {
      this.presentErrorToast(
        this.translateService.instant(
          "popups.magic-login-confirmation.please-enter-your-password"
        ),
        "danger"
      );
      this.loading = false;
    } else {
      if (
        this.groupApp &&
        this.groupApp.firebaseVerificationEnabled &&
        this.groupApp.webFirebase &&
        this.groupApp.webFirebase.apiKey &&
        !Capacitor.isNativePlatform()
      ) {
        console.log("window.confirmationResult", window.confirmationResult);
        if (window.confirmationResult) {
          let fireBaseApp = this.firebaseBrowserService.getFireBaseApp();
          const auth = getAuth(fireBaseApp);
          window.confirmationResult
            .confirm(this.newCustomer.password)
            .then((result) => {
              auth.currentUser
                .getIdToken(true)
                .then((idToken) => {
                  console.log("idToken", idToken); // Add here the token!
                  if (
                    this.newCustomer &&
                    this.newCustomer.password &&
                    this.newCustomer.password.length &&
                    idToken
                  ) {
                    this.writeToAuthStateDebounce("OK", idToken);
                    this.loading = false;
                  } else {
                    this.loading = false;
                    console.log("fill the password");
                    //handled by disable ok button
                  }
                })
                .catch((error) => {
                  // Handle error
                  console.log("handle error", error);
                  this.presentErrorToast(
                    this.translateService.instant(
                      "errorMessages.something_went_wrong_try_again"
                    ),
                    "danger"
                  );
                  this.loading = false;

                  if (error && error.message) {
                    console.log("error message", error.message);
                  }
                });
            })
            .catch((error) => {
              this.loading = false;

              // User couldn't sign in (bad verification code?)
              console.log("handle error", error);

              if (error.message) {
                console.log(error.code);
                if (error.code === "auth/invalid-verification-code") {
                  this.presentErrorToast(
                    this.translateService.instant(
                      "errorMessages.please_type_the_right_password"
                    ),
                    "danger"
                  );
                } else if (error.code === "auth/code-expired") {
                  this.presentErrorToast(
                    this.translateService.instant("errorMessages.code_expired"),
                    "danger"
                  );
                } else {
                  this.presentErrorToast(
                    this.translateService.instant(
                      "errorMessages.something_went_wrong_try_again"
                    ),
                    "danger"
                  );
                }
              }
            });
        } else if (this.newCustomer.gateway === "sms") {
          console.log("this.newCustomer", this.newCustomer);
          this.writeToAuthStateDebounce("OK", null);
        }
      } else if (
        this.groupApp &&
        this.groupApp.firebaseVerificationEnabled &&
        Capacitor.isNativePlatform()
      ) {
        if (window.firebaseVerificationId) {
          FirebaseAuthentication.confirmVerificationCode({
            verificationId: window.firebaseVerificationId,
            verificationCode: this.newCustomer.password,
          })
            .then(() => {
              console.log("Now get token id");
              FirebaseAuthentication.getIdToken().then((idToken) => {
                // send token to server to authenticate
                if (
                  this.newCustomer &&
                  this.newCustomer.password &&
                  this.newCustomer.password.length &&
                  idToken &&
                  idToken.token
                ) {
                  this.writeToAuthStateDebounce("OK", idToken.token);
                  this.loading = false;
                } else {
                  this.loading = false;
                  console.log("fill the password");
                  //handled by disable ok button
                }
              });
            })
            .catch((error_text) => {
              console.log("firebaseVerificationId Error", error_text);
              this.loading = false;
              this.presentErrorToast(error_text, "danger");
            });
        } else if (this.newCustomer.gateway === "sms") {
          console.log("this.newCustomer", this.newCustomer);
          this.writeToAuthStateDebounce("OK", null);
        } else {
          this.loading = false;
          console.log("window.firebaseVerificationId undefined!");
          this.presentErrorToast(
            this.translateService.instant(
              "errorMessages.something_went_wrong_try_again"
            ),
            "danger"
          );
        }
      }
      console.log("clicked");
    }
  }

  async onResend() {
    if (this.resendLoading) {
      return;
    }
    this.resendLoading = true;
    try {
      const { handled } = await this.handleResendGuestOfferFirstClick();
      if (handled) {
        return;
      }
      this.triggerResendSms();
    } finally {
      this.resendLoading = false;
    }
  }

  onChange() {
    if (
      this.ngOtpInputRef &&
      this.ngOtpInputRef.otpForm &&
      this.ngOtpInputRef.otpForm.value
    ) {
      let password = "";
      for (var ctrl in this.ngOtpInputRef.otpForm.value) {
        if (this.ngOtpInputRef.otpForm.value[ctrl]) {
          password = password + this.ngOtpInputRef.otpForm.value[ctrl];
        }
      }
      this.newCustomer.password = _.cloneDeep(password);
      if (
        this.newCustomer.password &&
        this.newCustomer.password.length &&
        this.newCustomer.password.length === 6
      ) {
        this.codeFull = true;
      } else {
        this.codeFull = false;
      }
      console.log("changed", password);
    }
  }

  writeToAuthStateDebounce = _.debounce((clickType, firebase_id_token) => {
    this.writeToAuthState(clickType, firebase_id_token);
  }, 100);

  writeToAuthState(clickType, firebase_id_token) {
    if (clickType === "OK") {
      var newCustomer = _.cloneDeep(this.newCustomer);
      newCustomer.firebase_id_token = firebase_id_token;
      console.log("newCustomer", newCustomer);
      this.store.dispatch(
        new AuthActions.SetNewCustomer(_.cloneDeep(newCustomer))
      );
      this.modalCtrl.dismiss(this.newCustomer);
    } else if (clickType === "resend") {
      if (!Capacitor.isNativePlatform()) {
        if (this.newCustomer && this.newCustomer.password) {
          this.newCustomer.password = null;
        }
        this.newCustomer.resend = true;
        this.store.dispatch(new AuthActions.ClearNewCustomer());
        this.store.dispatch(
          new AuthActions.SetNewCustomer(_.cloneDeep(this.newCustomer))
        );
        this.modalCtrl.dismiss(this.newCustomer);
      } else if (Capacitor.isNativePlatform()) {
        let newCustomer = {
          gateway: "sms",
          mobile: this.newCustomer.mobile,
          createOneTimePass: true,
        };
        console.log("resend sms mobile", newCustomer);
        this.store.dispatch(new AuthActions.ClearNewCustomer());
        this.store.dispatch(new AuthActions.SetNewCustomer(newCustomer));
      }
    }
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  async presentAlertSuccessLogin() {
    const alert = await this.alertCtrl.create({
      header: this.translateService.instant("homepage.magic-login"),
      message: this.translateService.instant(
        "popups.magic-login-confirmation.you-are-connect"
      ),
      buttons: [
        {
          text: "OK",
          handler: () => {},
        },
      ],
    });

    await alert.present();
  }

  ngOnDestroy() {
    this.destroyed = true;
    if (this.unsubscribeBackEvent) {
      this.unsubscribeBackEvent.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscription2) {
      this.subscription2.unsubscribe();
    }
    if (this.subscription3) {
      this.subscription3.unsubscribe();
    }
  }
}
